export default {
  buses: [],
};
